import { Component, inject, Input } from '@angular/core';
import { NgIf } from '@angular/common';

import { SideNavComponent } from '../side-nav';

@Component({
  selector: 'iss-portal-header',
  templateUrl: './portal-header.component.html',
  styleUrls: [ './portal-header.component.scss' ],
  standalone: true,
  imports: [
    NgIf,
  ],
})
export class PortalHeaderComponent {
  private readonly sideNav = inject(SideNavComponent);

  @Input({ required: true }) public name!: string | null;
  @Input() public subtext?: string | null;

  public get expanded(): boolean {
    return Boolean(this.sideNav.expanded);
  }
}
